import { render, staticRenderFns } from "./IconBase.vue?vue&type=template&id=5c4ef8f2&scoped=true&"
import script from "./IconBase.vue?vue&type=script&lang=js&"
export * from "./IconBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ef8f2",
  null
  
)

export default component.exports